module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chara-detail"
  }, [_c('transition', {
    attrs: {
      "name": "chara-loading"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_loading),
      expression: "is_loading"
    }],
    staticClass: "chara-loading p-loading"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "chara-detail__image"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.is_change_image),
      expression: "!is_change_image"
    }],
    staticClass: "chara-detail__image"
  }, [_c('img', {
    staticClass: "u-sz-w100-sp",
    attrs: {
      "src": _vm.image
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "chara-detail__text"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.is_loading),
      expression: "!is_loading"
    }],
    staticClass: "chara-detail__text"
  }, [_c('div', {
    staticClass: "chara-detail__name",
    domProps: {
      "innerHTML": _vm._s(_vm.chara.name)
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "chara-detail__name-en",
    domProps: {
      "innerHTML": _vm._s(_vm.chara.name_en)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chara-detail__cv"
  }, [_c('span', {
    staticClass: "chara-detail__cv-mark"
  }, [_vm._v("CV")]), _vm._v(" " + _vm._s(_vm.chara.cv_en) + "\n                "), _c('span', {
    staticClass: "chara-detail__cv-ja"
  }, [_vm._v(_vm._s(_vm.chara.cv))])]), _vm._v(" "), _c('div', {
    staticClass: "chara-detail__note",
    domProps: {
      "innerHTML": _vm._s(_vm.chara.note)
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "c-tabmenu chara-detail__tab"
  }, _vm._l((_vm.chara.images), function(image, index) {
    return _c('li', {
      key: index,
      staticClass: "c-tabmenu__item"
    }, [_c('a', {
      staticClass: "c-tabmenu__link",
      class: {
        'router-link-active': _vm.image_idx === index
      },
      on: {
        "click": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "prevent:")) { return null; }
          _vm.change_image(index)
        }
      }
    }, [_c('span', {
      staticClass: "c-tabmenu__text"
    }, [_vm._v(_vm._s(image.text))])])])
  }))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6f5a2ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/chara/chara-detail.vue
// module id = 59
// module chunks = 0